import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SplitButtonComponent } from './splitButton.component';

@NgModule({
	imports: [
		RouterModule.forChild([
			{
				path:'',
				component: SplitButtonComponent
			}
		])
	],
	exports: [
		RouterModule
	]
})
export class SplitRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/view/splitButton/split-routing.module.ts